const getTimeName = ({ count, name }) => {
  let end = ''

  const counterString = String(count)

  if (name === 'секунд' || name === 'минут') {
    if (!/11|12|13|14|15/.test(counterString)) {
      if (/1$/.test(counterString)) {
        end = 'у'
      }
      if (/(2|3|4)$/.test(counterString)) {
        end = 'ы'
      }
    }
  }

  if (name === 'час') {
    if (/(5|6|7|8|9|0)$/.test(counterString)) {
      end = 'ов'
    }
    if (/(2|3|4)$/.test(counterString)) {
      end = 'а'
    }
  }

  return `${name}${end}`
}


export default getTimeName
